import axiosServices from "../utils/axios";

export const fetchGradesList = async () => {
  const response = await axiosServices.get(`/grades`);
  return response.data.data;
};

export const addGradeData = async (data: { [key: string]: any }) => {
  const response = await axiosServices.post(`/grades`, data);
  return response?.data?.data;
};

export const updateGradeData = async (grade_id: string, data: { [key: string]: any }) => {
  const response = await axiosServices.put(`/grades/${grade_id}`, data);
  const payload = response?.data?.data;
  let updated: any = Array.isArray(payload) && payload.length >= 2 && Array.isArray(payload[1])
    ? payload[1][0]
    : payload;
  if (updated && !updated.grade_id) {
    updated.grade_id = grade_id;
  }
  return updated;
};

export const deleteGradeData = async (id: string) => {
  const response = await axiosServices.delete(`/grades/${id}`);
  return { success: response?.data?.success, id };
};
